import DeadlineItem from './DeadlineItem'

export default DeadlineItem
